import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoFlatColorPickerMixin from './KendoFlatColorPickerMixin'

export default {
    name: 'kendo-flatcolorpicker',
    mixins: [ KendoFlatColorPickerMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoFlatColorPicker/index.js